import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class VersionHelper {
  /**
   * Compares a version string against a reference version
   * @param versionString - The version string to compare (e.g., 'v3.0.5')
   * @param referenceVersion - The reference version to compare against (default: 'v3.0.6')
   * @returns true if versionString is lower than referenceVersion, false otherwise
   */
  public isVersionLowerThan(versionString: string, referenceVersion: string = 'v3.0.6'): boolean {
    if (!versionString || !referenceVersion) {
      return false;
    }

    // Extract version components using regex and convert to numbers
    const parseVersion = (str: string | null | undefined): number[] => {
      if (!str) return [0, 0, 0];

      const match = str.match(/v?(\d+)\.(\d+)\.(\d+)/i);
      return match ? [1, 2, 3].map((i) => parseInt(match[i])) : [0, 0, 0];
    };

    const current = parseVersion(versionString);
    const reference = parseVersion(referenceVersion);

    // Compare version components sequentially
    for (let i = 0; i < 3; i++) {
      if (current[i] !== reference[i]) {
        return current[i] < reference[i];
      }
    }

    return false; // Versions are equal
  }
}
